import React from 'react'
import iconCheck from 'images/icons/check.svg'
import { useSelector, useDispatch } from 'react-redux';

const StepNavigationHeader = (props) => {
  const { currentStep } = useSelector(state => state.createPersona );
  const dispatch = useDispatch();

  console.log(currentStep)
  const renderDesktopExtraClass = (index) => {
    if (currentStep === index + 1) return 'step-navigation__link--active'
    if (currentStep >= index + 2) return 'step-navigation__link--completed'
    return ''
  };

  const renderMobileExtraClass = (index) => {
    if (currentStep === index + 1) return 'step-navigation__link--active'
    if (currentStep === index) return 'step-navigation__link--next'
    return ''
  };

  return (
    <React.Fragment>
      <header
        className="bg-white border-bottom border-gallery col-12 fixed flex flex-center flex-justify left-0 px-40 sm-px2 top-0 z5"
        style={{ height: '80px' }}
      >
        <div className="col-4 px-40 sm-p0">
          <a className="logo" href="/" />
        </div>

        <div className="col-4 md-col-12">
          <nav className="fs-13 md-show sfpro-regular">
            <ul className="flex h-32 md-flex-justify-end">
              {props.menu.map((item, index) => (
                <li
                  className={`step-navigation__link ${renderMobileExtraClass(index)}`}
                  key={item}
                >
                  <a onClick={() => currentStep >= index + 1 && dispatch({type: 'NEXT_STEP', payload: index + 1})}>
                    <span className={`step-navigation__number ${currentStep >= index + 1 ? 'cursor-pointer' : ''}`}>{index + 1}</span>
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="flex flex-justify-center fs-13 lh-32 md-hide sfpro-regular">
            <ul className="flex">
              {props.menu.map((item, index) => (
                <li
                  className={`step-navigation__link ${renderDesktopExtraClass(index)}`}
                  key={item}
                >
                  <a
                    className={`flex flex-center ${currentStep >= index + 1 ? 'cursor-pointer' : ''}`}
                    onClick={() => currentStep >= index + 1 && dispatch({type: 'NEXT_STEP', payload: index + 1})}
                  >
                    {currentStep >= index + 2
                      && (
                        <span className="step-navigation__icon">
                          <img alt="" src={iconCheck} />
                        </span>
                      )
                      || <span className="step-navigation__number">{index + 1}</span>
                    }
                    <span>{item}</span>
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="col-4 flex flex-justify-end md-hide">
          <a
            className="btn btn--primary btn--primary--desert-storm btn--fs-12 btn--lh-28"
            href={props.cancelUrl}
            style={{ minWidth: '120px' }}
          >
            Cancel
          </a>
        </div>
      </header>
    </React.Fragment>
  );
}

export default StepNavigationHeader
